import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { trackEvent, EVENT_TYPE_CTA, EVENT_TYPE_PAGE } from "../utils/trackEvent.jsx";
import { Card, CardHeader, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const ProductList = ({ productType, lenders }) => {
  const navigate = useNavigate();
  const [expandedLender, setExpandedLender] = useState(null);
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, [isLoggedIn, navigate]);

  const toggleDetails = (index) => {
    setExpandedLender(expandedLender === index ? null : index);
  };

  if (!lenders || lenders.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
            <div className="w-16 h-16 rounded-full bg-[#1a4a1a]/10 flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-[#1a4a1a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a4a1a] mb-4">
              We're Expanding Our Network
            </h2>
            <p className="text-[#1a4a1a]/90 text-lg mb-8 max-w-2xl mx-auto">
              While we're in the process of adding more halal {productType} partners to our platform, our team is ready to help you find the right financial solution for your {productType === 'business' ? 'business growth' : 'nonprofit mission'}.
            </p>
            <Button
              onClick={() => navigate('/consult')}
              className="bg-[#1a4a1a] hover:bg-[#1a4a1a]/90 text-white font-semibold px-8 py-6 rounded-xl shadow-lg transition-all duration-300 hover:scale-105"
            >
              Get Personalized Assistance
            </Button>
            <p className="text-sm text-[#1a4a1a]/70 mt-6">
              Our experts will connect you with trusted halal financial partners within 3-5 business days.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
          {productType.charAt(0).toUpperCase() + productType.slice(1)} Products
        </h1>
        <div className="grid gap-6">
          {lenders.map((lender, index) => (
            <Card key={lender.id} className="overflow-hidden">
              <CardHeader>
                <h2 className="text-xl font-semibold">{lender.name}</h2>
                <h3 className="text-lg text-gray-600">{lender.product}</h3>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-gray-600">{lender.description}</p>
                <Button
                  variant="outline"
                  onClick={() => toggleDetails(index)}
                  className="w-full hover:bg-[#1a4a1a]/5 border-[#1a4a1a] text-[#1a4a1a]"
                >
                  {expandedLender === index ? "Hide Details" : "View Details"}
                </Button>
                {expandedLender === index && (
                  <p className="text-sm text-gray-600 mt-4 p-4 bg-gray-50 rounded-lg">
                    {lender.details}
                  </p>
                )}
              </CardContent>
              <CardFooter>
                <Button
                  className="w-full bg-[#1a4a1a] hover:bg-[#1a4a1a]/90 text-white font-semibold rounded-[28px] py-6 shadow-lg transition-all duration-300"
                  onClick={(e) => {
                    e.preventDefault();
                    trackEvent(EVENT_TYPE_CTA, lender.id);
                    window.open(lender.applyUrl, '_blank');
                  }}
                >
                  Apply Now
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductList;

